import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg text-sm font-medium transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-primary text-primary-foreground shadow-orange-button hover:bg-[hsl(24,100%,45%)] hover:shadow-orange-glow hover:-translate-y-0.5",
        destructive:
          "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90",
        outline:
          "border border-border bg-transparent text-foreground shadow-sm hover:bg-accent hover:text-accent-foreground hover:border-primary/50",
        secondary:
          "bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80",
        ghost: "text-foreground hover:bg-accent hover:text-foreground",
        link: "text-primary underline-offset-4 hover:underline",
        // GoTurkeyTransfer Custom Variants
        cta: "bg-primary text-primary-foreground font-semibold shadow-orange-button hover:bg-[hsl(24,100%,45%)] hover:shadow-orange-glow hover:-translate-y-0.5",
        ctaLarge: "bg-primary text-primary-foreground font-bold text-base shadow-orange-button hover:bg-[hsl(24,100%,45%)] hover:shadow-orange-glow hover:-translate-y-1",
        navCta: "bg-primary text-primary-foreground font-semibold rounded-full shadow-orange-button hover:bg-[hsl(24,100%,45%)] hover:shadow-orange-glow",
        outlineLight: "border border-foreground/30 bg-transparent text-foreground hover:border-primary hover:text-primary",
        white: "bg-foreground text-background font-semibold hover:bg-foreground/90",
      },
      size: {
        default: "h-10 px-5 py-2",
        sm: "h-9 rounded-md px-4 text-xs",
        lg: "h-12 rounded-lg px-8 text-base",
        xl: "h-14 rounded-lg px-10 text-lg",
        icon: "h-10 w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }